export default __webpack_public_path__ + "static/media/st_help1.70a7ff42.jpg";